"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var misc = {
  radius: '3px',
  lineHeight: 1.6,
  animationDuration: '0.25s',
  inputs: {
    padding: '8px'
  },
  avatar: {
    small: '24px',
    medium: '48px',
    large: '72px'
  },
  button: {
    // large: { height: '48px' },
    // default: { height: '44px' },
    // small: { height: '36px' }
    large: {
      height: '36px'
    },
    "default": {
      height: '36px'
    },
    small: {
      height: '36px'
    }
  },
  badge: {
    "default": {
      height: '26px'
    }
  }
};
var _default = misc;
exports["default"] = _default;